import { tw } from "@careinfo/tailwind";
import loadable from "@loadable/component";
import APIS from "../../constant/Endpoint";
import usePostHook from "../../customHooks/usePostHook";
const CreateSuppliercomponent = loadable(
  () => import("../../components/Supplier/CreateSupplier")
);
const CreateSupplier = () => {
  const { mutateAsync, isPostLoading } = usePostHook({
    queryKey: ["party-info"],
    navigateURL: "/accounting/supplier",
  });

  const handleCreate = async (values: any, setError: any) => {
    const url = APIS.CREATE_USER;
    const formData = {
      ...values,
      is_supplier: true,
    };

    try {
      const res = await mutateAsync({ url, formData, setError });
      if (res?.status === 201) {
      }
    } catch (err) {
      console.error(err);
    }
  };
  return (
    <div>
      <div className={tw`grid grid-cols-2 `}>
        <h1 className={tw`font-semibold text-xl leading-10`}>
          Create Supplier
        </h1>
      </div>
      <CreateSuppliercomponent
        handleCreate={handleCreate}
        isLoading={isPostLoading}
      />
    </div>
  );
};

export default CreateSupplier;

